import * as React from 'react';
import {
    MoreLessGroup,
    LinkMoreLessWrapper,
    ChevronIconWrapper,
} from 'src/domains/sportsbook/webview/components/expandButton/ExpandButton.style';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { ChevronWrapper } from 'src/ui/components/collapse/sports/05/Collapse.style';
import { useAppStateContext } from 'src/appState/AppState';

interface PropsType {
    isExpanded: boolean;
    isHomepage?: boolean;
    toggleExpand(e: React.MouseEvent): void;
}

export const ExpandButton = ({ isExpanded, isHomepage, toggleExpand }: PropsType): JSX.Element => {
    const {
        componentVariants: { sportsbookVariant },
        unifiedSportEventsTable,
    } = useAppStateContext().unifiedComponentConfig;

    const renderExpanButton = () =>
        unifiedSportEventsTable ? (
            <>
                {isExpanded ? (
                    <I18n
                        langKey='events.selections-group.showLess'
                        defaultText='Show Less'
                    />
                ) : (
                    <I18n
                        langKey='events.selections-group.showMore'
                        defaultText='Show More'
                    />
                )}
                <ChevronWrapper
                    size={20}
                    position={isExpanded ? 'up' : 'down'}
                />
            </>
        ) : (
            <>
                {isExpanded ? (
                    <I18n
                        langKey='events.selections-group.less'
                        defaultText='Less'
                    />
                ) : (
                    <I18n
                        langKey='events.selections-group.more'
                        defaultText='More'
                    />
                )}
                <ChevronIconWrapper position={isExpanded ? 'up' : 'down'} />
            </>
        );
    return (
        <MoreLessGroup
            isHomepage={isHomepage}
            variant={sportsbookVariant}
        >
            <LinkMoreLessWrapper onClick={toggleExpand}>{renderExpanButton()}</LinkMoreLessWrapper>
        </MoreLessGroup>
    );
};
